<app-content *ngIf='subpage() as subpage'>
  <app-breadcrumbs>
    <li>
      {{ subpage.titleSubpage }}
    </li>
  </app-breadcrumbs>
  <section class="editor-content">
    <h2>
      {{ subpage.titleSubpage }}
    </h2>
    <div [innerHTML]='subpage?.content'></div>
  </section>
</app-content>
